export default __webpack_public_path__ + "static/media/refresh.96625596.svg";